<template>
  <div id="app">
    <HeaderHome v-if="!paginaInterna"/>
    <HeaderInterno v-else/>
    <!--    <div id="preloader"></div>-->
    <router-view></router-view>
    <Footer/>
  </div>
</template>

<script>
import HeaderHome from 'Homepage/common/headers/HeaderHome.vue';
import HeaderInterno from 'Homepage/common/headers/HeaderInterno.vue';
import Footer from 'Homepage/common/Footer.vue';

export default {
  name: 'App',
  beforeCreate() {
    document.title = 'Sky Solar - Distribuidora de Geradores e Produtos Fotovoltaicos';
    document.documentElement.setAttribute('lang', 'pt-br');

    let meta = document.createElement('meta');
    meta.httpEquiv = 'Content-Language';
    meta.content = 'pt-br';

    let script = document.createElement('script');
    script.src = 'https://www.google-analytics.com/analytics.js';
    script.type = 'text/javascript';
    script.async = true;
    document.head.appendChild(script);

    script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-JTS60ZN7DW&amp;l=dataLayer&amp;cx=c';
    script.type = 'text/javascript';
    script.async = true;
    document.head.appendChild(script);

    script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=UA-189596652-1';
    script.async = true;
    document.head.appendChild(script);

    script = document.createElement('script');
    script.src = 'https://cdn.widgetwhats.com/script.min.js';
    script.async = true;
    script.dataset.id = '73347';
    document.head.appendChild(script);

    script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = 'window.dataLayer = window.dataLayer || [];\n'
      + '        function gtag(){dataLayer.push(arguments);}\n'
      + "        gtag('js', new Date());\n"
      + "        gtag('config', 'UA-189596652-1');";
    document.head.appendChild(script);

    meta = document.createElement('meta');
    meta.name = 'description';
    meta.content = 'Fabricante e Distribuidora de geradores e produtos fotovoltaicos '
      + 'exclusivamente para integradores. Entrega rápida e segura. Cadastre-se!';
    document.head.appendChild(meta);

    meta = document.createElement('meta');
    meta.name = 'keywords';
    meta.content = 'energia solar, energia, distribuidora, distribuidora fotovoltaica, '
      + 'distribuidora solar, kit fotovoltaico, geradores, gerador fotovoltaico, geradores '
      + 'fotovoltaicos, romagnole, chint, growatt, saj, amerisolar, dah solar, seraphim';

    document.head.appendChild(meta);
  },
  components: {
    HeaderHome,
    HeaderInterno,
    Footer,
  },
  computed: {
    paginaInterna() {
      return this.$route.path !== '/';
    },
  },
};
</script>
